@for(option of options(); track option.label) {
  @let selected = option.value === value();
  <button
    type="button"
    [attr.aria-label]="option.label"
    [attr.data-first]="$first || null"
    [attr.data-last]="$last || null"
    [attr.data-selected]="selected || null"
    [disabled]="option.disabled"
    (click)="handleChange(option.value)"
  >
    <span data-outer>
      <span data-inner>
        @if (selected && option.iconActive; as icon) {
          <bspk-icon [name]="icon" />
        }
        {{ option.label }}
      </span>
    </span>
  </button>
}
